import { jsx as D } from "react/jsx-runtime";
import { createContext as Mt, useMemo as v, useCallback as h, useState as p, useRef as R, useEffect as b, useContext as Ot } from "react";
import { useReactTable as Ye, getGroupedRowModel as qe, getCoreRowModel as He, getPaginationRowModel as Tt, getFilteredRowModel as Et, getSortedRowModel as Ft, getExpandedRowModel as Nt } from "@tanstack/react-table";
import { formatColumnName as Xe, handleSortingChange as It, getSelectedRowPageFromTable as Gt } from "../components/organisms/Table/utils.js";
import { IconButton as zt, TableSortLabel as At } from "@mui/material";
import jt from "@mui/icons-material/KeyboardArrowDown";
import Ct from "@mui/icons-material/KeyboardArrowRight";
import $ from "moment-timezone";
var x = /* @__PURE__ */ ((S) => (S.TEXT = "text", S.OPTIONS = "options", S.TIME_RANGE = "time_range", S))(x || {}), ne = /* @__PURE__ */ ((S) => (S.IN = "in", S.NOT_IN = "not_in", S))(ne || {});
const Ve = Mt(void 0);
function Ht() {
  const S = Ot(Ve);
  if (!S)
    throw new Error("useTableContext must be used within a TableContextProvider");
  return S;
}
function Xt({
  children: S,
  data: g,
  columns: M,
  groupByColumns: l = [],
  defaultExpanded: xe = !0,
  persistExpanded: k = !0,
  persistKey: _,
  persistStrategy: Me = "reset",
  defaultSorting: re = [],
  disableFilters: se = !1,
  defaultColumnFilters: $e = [],
  disableSorting: Ue = !1,
  emptyStateComponent: We,
  isLoading: Qe,
  enableVirtualization: N = !1,
  hiddenColumns: oe = [],
  height: Ze,
  minHeight: Be,
  maxHeight: et,
  enableSelection: L,
  onSelectionChange: O,
  selectedRowIndex: K,
  preSelectedRows: y,
  isRowSelectionDisabled: ie,
  rowSx: tt,
  headerSx: nt,
  onRowClick: ae,
  onRowRightClick: Oe,
  onRowEnter: le,
  onRowLeave: ce,
  drag: Y = {},
  pagination: c = {},
  search: q = {},
  footerLeftComponent: rt,
  selectedRowId: H,
  showColumnVisibilitySidebar: T = !1
}) {
  const U = Ye({
    data: g,
    columns: M,
    getCoreRowModel: He(),
    getGroupedRowModel: l.length > 0 ? qe() : void 0,
    state: {
      grouping: l.length > 0 ? l : []
    }
  }), m = v(() => {
    if (l.length === 0) return {};
    const e = {}, n = U.getGroupedRowModel().rows, o = (i) => {
      e[i.id] = !0, i.subRows && i.subRows.length > 0 && i.subRows.forEach((s) => {
        o(s);
      });
    }, r = (i) => {
      const s = i.getIsGrouped() ? l[i.depth] : null;
      if (s) {
        const t = M.find((f) => f.id === s || f.accessorKey === s);
        t?.hideGroupingRow?.(i) ?? !1 ? o(i) : xe && !t?.hideGroupingValues?.(i) && (e[i.id] = !0);
      }
      i.subRows && i.subRows.forEach(r);
    };
    return n.forEach(r), e;
  }, [xe, l, U, M, g]), W = v(() => JSON.stringify(m), [m]), P = v(() => {
    if (l.length === 0) return /* @__PURE__ */ new Set();
    const e = /* @__PURE__ */ new Set(), n = U.getGroupedRowModel().rows, o = (r) => {
      r.getCanExpand() && e.add(r.id), r.subRows?.length && r.subRows.forEach(o);
    };
    return n.forEach(o), e;
  }, [l, U, g]), w = h(() => _ || `h9_table_expanded:${typeof window < "u" && window.location && window.location.pathname ? window.location.pathname : "unknown"}:${JSON.stringify(l)}`, [_, l]), fe = h(() => {
    try {
      const e = sessionStorage.getItem(w());
      if (!e) return null;
      const n = JSON.parse(e);
      if (typeof n == "boolean")
        return n;
      if (!n || typeof n != "object" || P.size === 0)
        return null;
      const o = {};
      for (const [r, i] of Object.entries(n))
        P.has(r) && (o[r] = !!i);
      return Object.keys(o).length === 0 ? null : o;
    } catch {
      return null;
    }
  }, [P, w]), ue = h((e) => {
    if (e === !0) return !0;
    const n = {}, o = typeof m == "object" && m !== null ? m : {};
    return P.forEach((r) => {
      r in e ? e[r] && (n[r] = !0) : o[r] && (n[r] = !0);
    }), n;
  }, [P, m]), [E, X] = p(() => {
    if (!k) return m;
    const e = fe();
    return e !== null ? ue(e) : m;
  }), Te = R(JSON.stringify(l)), Ee = R(g.length), Q = v(() => Array.from(P).sort().join("|"), [P]), Fe = R(Q), Ne = R(W), Ie = R(!1);
  b(() => {
    const e = JSON.stringify(l), n = Te.current !== e, o = Fe.current !== Q, r = Ne.current !== W;
    if (n || o || g.length > 0 && Ee.current === 0 || r) {
      if (k)
        if (Me === "keep") {
          const i = fe();
          X(i !== null ? ue(i) : m);
        } else {
          try {
            sessionStorage.removeItem(w());
          } catch {
          }
          X(m);
        }
      else
        X(m);
      Te.current = e, Fe.current = Q, Ne.current = W, P.size > 0 && (Ie.current = !0);
    }
    Ee.current = g.length;
  }, [ue, g.length, P, w, fe, l, Q, m, W, k, Me]), b(() => {
    if (!k) return;
    const e = typeof E == "object" && E !== null;
    if (!(e && Object.keys(E).length === 0 && !Ie.current))
      try {
        if (typeof E == "boolean") {
          sessionStorage.setItem(w(), JSON.stringify(E));
          return;
        }
        const o = {};
        try {
          const r = sessionStorage.getItem(w());
          if (r) {
            const i = JSON.parse(r);
            if (i && typeof i == "object")
              for (const [s, t] of Object.entries(i))
                P.has(s) || (o[s] = !!t);
          }
        } catch {
        }
        if (e) {
          const r = E;
          P.forEach((i) => {
            o[i] = !!r[i];
          });
        }
        sessionStorage.setItem(w(), JSON.stringify(o));
      } catch {
      }
  }, [E, P, w, k]);
  const st = l.length > 0 ? l : [], ot = v(() => {
    const e = re || [], n = new Set(e.map((o) => o.id));
    return l.length > 0 ? [...l.filter((r) => !n.has(r)).map((r) => ({
      id: r,
      desc: !1
    })), ...e] : e;
  }, [re, l]), [F, Z] = p(ot), de = R(JSON.stringify(l));
  b(() => {
    const e = JSON.stringify(l), n = de.current !== e;
    if (n && l.length > 0) {
      const o = new Set(F.map((t) => t.id)), r = re || [], i = new Set(r.map((t) => t.id)), s = l.filter((t) => !o.has(t) && !i.has(t));
      if (s.length > 0) {
        const t = s.map((a) => ({
          id: a,
          desc: !1
        }));
        Z([...t, ...F]);
      }
      de.current = e;
    } else n && (de.current = e);
  }, [l]);
  const B = R("");
  b(() => {
    if (l.length > 0) {
      const e = F.filter((s) => l.includes(s.id)), n = F.filter((s) => !l.includes(s.id)), r = [...l.map((s) => ({
        id: s,
        desc: !1
      })), ...n], i = JSON.stringify(r);
      if (i !== B.current) {
        const s = JSON.stringify(F), t = e.some((a) => a.desc === !0) || e.length > 0 && F.length > 0 && !l.includes(F[0].id) || l.some((a) => !e.some((f) => f.id === a));
        t && s !== i ? (Z(r), B.current = i) : t || (B.current = s);
      }
    } else
      B.current = "";
  }, [F, l]);
  const Ge = R({}), [G, ge] = p($e), [ze, it] = p(""), at = h((e) => {
    it(e), q?.onSearchChange?.(e);
  }, [q]), Ae = h((e, n) => {
    if (!n || n.trim() === "")
      return e;
    const o = n.toLowerCase().trim();
    return e.filter((r, i) => M.some((s) => {
      if (s.enableGlobalFilter === !1)
        return !1;
      let t;
      if (s.accessorFn)
        t = s.accessorFn(r, i);
      else if (s.accessorKey) {
        const u = s.accessorKey.split(".");
        t = r;
        for (const d of u)
          if (t && typeof t == "object")
            t = t[d];
          else {
            t = void 0;
            break;
          }
      }
      t == null && (t = "");
      const a = s?.filterType === x.TIME_RANGE;
      let f;
      if (a && typeof t == "number") {
        const u = String(t).length <= 10 ? t * 1e3 : t, d = s?.timeFormat || "MMM DD, YYYY h:mm A z";
        f = $(u).tz(s?.timezone || "UTC").format(d).toLowerCase();
      } else
        Array.isArray(t) ? f = t.join(" ").toLowerCase() : f = String(t).toLowerCase();
      return f.includes(o);
    }));
  }, [M]), V = v(() => Ae(g, ze), [g, ze, Ae]), [je, Ce] = p({}), [lt, Je] = p(!1), [ct, De] = p(null), [z, ft] = p(c?.defaultPageSize || 10), [ut, he] = p(0), ee = c?.isManualPagination ? c.currentPage || 0 : ut, C = v(() => c?.isManualPagination ? (e) => c.onPaginationChange?.(e) : he, [c]);
  b(() => {
    c?.isManualPagination && c.onPaginationChange && c.onPaginationChange(1);
  }, [c.totalPages]);
  const ke = c?.hideRowsPerPageSelector, [Se, te] = p(() => y && y.length > 0 ? new Set(y.map((e) => JSON.stringify(e))) : /* @__PURE__ */ new Set()), dt = h((e, n) => {
    Ce((o) => ({
      ...o,
      [e]: n
    }));
  }, []), gt = h((e) => {
    Je(!0), De(e);
  }, []), ht = h(() => {
    Je(!1), De(null);
  }, []), St = h((e, n, o, r) => {
    ae?.(e, n, o, r);
  }, [ae]), mt = h((e, n, o) => {
    Oe?.(e, n, o);
  }, [Oe]), Pt = h((e, n, o) => {
    le?.(e, n, o);
  }, [le]), pt = h((e, n, o) => {
    ce?.(e, n, o);
  }, [ce]), I = h((e) => M.find((n) => n.id === e || n.accessorKey === e), [M]), me = h((e) => {
    const n = I(e);
    if (!n) return [];
    if (n.filterOptions) {
      const t = Array.from(new Map(n.filterOptions.map((a) => [String(a.value), a])).values()).map((a) => a.value);
      return Ge.current[e] = t, t;
    }
    const o = g.map((s, t) => {
      if (n.accessorFn)
        return n.accessorFn(s, t);
      const a = n.accessorKey;
      if (!a) return;
      const f = String(a).split(".");
      let u = s;
      for (const d of f)
        if (u && typeof u == "object")
          u = u[d];
        else
          return;
      return u;
    }).filter((s) => s != null && s !== "" && !(typeof s == "string" && s.trim() === "")), r = /* @__PURE__ */ new Map();
    o.forEach((s) => {
      const t = String(s);
      r.has(t) || r.set(t, s);
    });
    const i = Array.from(r.values()).sort((s, t) => {
      if (typeof s == "number" && typeof t == "number")
        return s - t;
      if (s instanceof Date && t instanceof Date)
        return s.getTime() - t.getTime();
      if (typeof s == "string" && typeof t == "string")
        return s.localeCompare(t, void 0, {
          numeric: !0,
          sensitivity: "base"
        });
      const a = {
        number: 1,
        string: 2,
        boolean: 3,
        object: 4,
        undefined: 5
      }, f = typeof s, u = typeof t;
      return f !== u ? (a[f] || 6) - (a[u] || 6) : String(s).localeCompare(String(t), void 0, {
        numeric: !0
      });
    });
    return Ge.current[e] = i, i;
  }, [g, I]), Pe = v(() => ({
    id: "expander",
    header: () => null,
    cell: ({
      row: e
    }) => e.getCanExpand() ? /* @__PURE__ */ D(zt, { onClick: () => e.toggleExpanded(), size: "small", children: e.getIsExpanded() ? /* @__PURE__ */ D(jt, {}) : /* @__PURE__ */ D(Ct, {}) }) : null,
    width: "48px",
    enableSorting: !1
  }), []), pe = h((e) => {
    const n = e.filter((o) => !oe.includes(o.id || o.accessorKey)).map((o) => {
      const r = o;
      return r.filterType === x.TIME_RANGE && !r.cell && !r.accessorFn && (r.cell = ({
        row: i,
        column: s
      }) => {
        const t = i.getValue(s.id);
        if (typeof t == "number") {
          const a = String(t).length <= 10 ? t * 1e3 : t, f = r.timeFormat || "MMM DD, YYYY h:mm A z";
          return $(a).format(f);
        }
        return t;
      }), {
        ...r,
        enableSorting: r.disableSorting !== void 0 ? !r.disableSorting : !0,
        enableFilter: se ? !1 : r.disableFilter !== void 0 ? !r.disableFilter : !0,
        enableResizing: !0,
        filterFn: r.filterFn || "customFilter",
        header: ({
          column: i
        }) => {
          let s;
          if (r.header !== void 0)
            if (typeof r.header == "function")
              try {
                const a = r.header;
                s = /* @__PURE__ */ D(a, {});
              } catch {
                s = Xe(r.accessorKey);
              }
            else
              s = r.header;
          else
            s = Xe(r.accessorKey);
          if (!i.getCanSort())
            return s;
          const t = l.includes(i.id);
          return /* @__PURE__ */ D(At, { active: i.getIsSorted() !== !1, direction: i.getIsSorted() === "desc" ? "desc" : "asc", onClick: () => !t && It(i.id, Z, l), sx: {
            width: "100%"
          }, children: s });
        }
      };
    });
    return l.length > 0 ? [Pe, ...n] : n;
  }, [Pe, l, se, oe]), be = v(() => pe(M), [M, pe]), A = v(() => be.map((e) => e.id), [be]), j = v(() => !_ || !T ? null : `h9_table_columns:${w()}`, [_, T, w]), [ve, bt] = p(() => {
    if (!j) return {};
    try {
      const e = localStorage.getItem(j);
      if (e) {
        const n = JSON.parse(e);
        if (n?.columnVisibility && typeof n.columnVisibility == "object") return n.columnVisibility;
      }
    } catch {
    }
    return {};
  }), [Re, _e] = p(() => {
    if (!j) return A;
    try {
      const e = localStorage.getItem(j);
      if (e) {
        const n = JSON.parse(e);
        if (Array.isArray(n?.columnOrder) && n.columnOrder.length > 0) {
          const o = new Set(A), r = n.columnOrder.filter((s) => o.has(s)), i = A.filter((s) => !r.includes(s));
          return [...r, ...i];
        }
      }
    } catch {
    }
    return A;
  });
  b(() => {
    T && _e((e) => {
      const n = new Set(A), o = e.filter((i) => n.has(i)), r = A.filter((i) => !o.includes(i));
      return r.length === 0 ? e : [...o, ...r];
    });
  }, [A, T]), b(() => {
    if (j)
      try {
        localStorage.setItem(j, JSON.stringify({
          columnVisibility: ve,
          columnOrder: Re
        }));
      } catch {
      }
  }, [ve, Re, j]);
  const vt = h((e, n) => {
    C(0), ge((o) => {
      if ((I(e)?.filterType || x.OPTIONS) === x.TEXT) {
        const s = o.filter((t) => t.id !== e);
        return n ? [...s, {
          id: e,
          value: n
        }] : s;
      } else if (n && typeof n == "object" && "value" in n && "operator" in n) {
        const t = n.value, a = o.findIndex((f) => f.id !== e ? !1 : f.value === t ? !0 : f.value && typeof f.value == "object" && "value" in f.value ? f.value.value === t : !1);
        return a >= 0 ? o.filter((f, u) => u !== a) : [...o, {
          id: e,
          value: n
        }];
      } else {
        const s = o.findIndex((t) => t.id === e && t.value === n);
        return s >= 0 ? o.filter((t, a) => a !== s) : [...o, {
          id: e,
          value: n
        }];
      }
    });
  }, [I, C]), J = Ye({
    data: V,
    columns: be,
    state: {
      expanded: E,
      grouping: l.length > 0 ? st : [],
      sorting: F,
      columnFilters: G,
      columnSizing: je,
      columnVisibility: T ? ve : void 0,
      columnOrder: T ? Re : void 0,
      pagination: c?.disablePagination || c?.isManualPagination || N ? void 0 : {
        pageIndex: ee,
        pageSize: z
      }
    },
    onExpandedChange: X,
    onSortingChange: Z,
    onPaginationChange: (e) => {
      c?.isManualPagination || c?.disablePagination || N || he((n) => (typeof e == "function" ? e({
        pageIndex: n,
        pageSize: z
      }) : e).pageIndex);
    },
    autoResetPageIndex: !1,
    onColumnVisibilityChange: T ? bt : void 0,
    onColumnOrderChange: T ? _e : void 0,
    getExpandedRowModel: Nt(),
    getGroupedRowModel: l.length > 0 ? qe() : void 0,
    getCoreRowModel: He(),
    getSortedRowModel: Ft(),
    getFilteredRowModel: Et(),
    getPaginationRowModel: c?.disablePagination || c?.isManualPagination || N ? void 0 : Tt(),
    enableExpanding: l.length > 0,
    enableSorting: !Ue,
    enableFilters: !0,
    autoResetExpanded: !1,
    manualPagination: c?.isManualPagination,
    filterFns: {
      customFilter: (e, n) => {
        const o = I(n), r = e.getValue(n), i = o?.filterType || x.OPTIONS, s = G.filter((t) => t.id === n).map((t) => t.value);
        if (s.length === 0) return !0;
        if (i === x.TIME_RANGE) {
          const t = s[0];
          if (!t || !t.startTime && !t.endTime) return !0;
          const a = r, f = String(a).length <= 10 ? a * 1e3 : a, u = $(f).valueOf(), d = t.startTime ? $(t.startTime).valueOf() : -1 / 0, we = t.endTime ? $(t.endTime).valueOf() : 1 / 0;
          return u >= d && u <= we;
        }
        if (i === x.TEXT) {
          const t = s[0];
          if (!t || !t.value) return !0;
          const a = t.value.toLowerCase().trim(), f = r?.toString().toLowerCase() || "";
          return t.operator === ne.IN ? f.includes(a) : !f.includes(a);
        } else {
          let t = ne.IN;
          for (const d of G.filter((we) => we.id === n))
            if (d.value && typeof d.value == "object" && "operator" in d.value) {
              t = d.value.operator;
              break;
            }
          const a = s.map((d) => d && typeof d == "object" && "value" in d ? d.value : d), u = (Array.isArray(r) ? r : [r]).some((d) => a.includes(d));
          return t === ne.IN ? u : !u;
        }
      }
    },
    filterFromLeafRows: !0,
    groupedColumnMode: "remove",
    columnResizeMode: "onChange",
    onColumnSizingChange: Ce,
    enableColumnResizing: !0
  }), Le = R(V.length), ye = R(J), Ke = R(g);
  Ke.current = g, b(() => {
    ye.current = J;
  }, [J]), b(() => {
    if (c?.disablePagination || c?.isManualPagination || N)
      return;
    const e = H != null, n = typeof K == "number" && K >= 0;
    if (!e && !n)
      return;
    const o = Gt(ye.current, z, {
      selectedRowId: H,
      selectedRowIndex: K,
      data: Ke.current
    });
    o !== null && he((r) => r === o ? r : o);
  }, [H, K, z, c?.disablePagination, c?.isManualPagination, N]), b(() => {
    if (c?.disablePagination || c?.isManualPagination || N)
      return;
    if (Le.current !== V.length) {
      Le.current = V.length;
      const n = ye.current.getRowCount(), o = Math.ceil(n / z);
      o > 0 && ee >= o ? C(o - 1) : o === 0 && ee > 0 && C(0);
    }
  }, [V.length, z, C, c?.disablePagination, c?.isManualPagination, N]), b(() => {
    if (y)
      if (y.length > 0) {
        const e = new Set(y.map((n) => JSON.stringify(n)));
        te((n) => {
          let o = y.length !== n.size;
          if (!o) {
            for (const r of n)
              if (!e.has(r)) {
                o = !0;
                break;
              }
          }
          return o ? e : n;
        });
      } else y.length === 0 && te(/* @__PURE__ */ new Set());
  }, [y]), b(() => {
    const e = G.filter((n) => {
      const o = I(n.id);
      if (!o) return !1;
      const r = me(n.id);
      if (o.filterType === x.TEXT || o.filterType === x.TIME_RANGE) return !0;
      const i = n.value;
      if (i == null) return !1;
      const s = typeof i == "object" && "value" in i ? i.value : i;
      return r.some((t) => t === s);
    });
    e.length !== G.length && ge(e);
  }, [g, G, I, me]);
  const Rt = h((e) => {
    L && te((n) => {
      const o = new Set(n);
      return o.has(e) ? o.delete(e) : o.add(e), O && setTimeout(() => {
        if (o.size === 0)
          O([]);
        else {
          const r = g.filter((i) => o.has(JSON.stringify(i)));
          O(r);
        }
      }, 0), o;
    });
  }, [L, g, O]), yt = h(() => {
    L && te((e) => {
      const r = J.getFilteredRowModel().rows.filter((t) => !ie?.(t.original, t.index)).map((t) => JSON.stringify(t.original)), i = r.length > 0 && r.every((t) => e.has(t));
      let s;
      return i ? (s = new Set(e), r.forEach((t) => s.delete(t))) : (s = new Set(e), r.forEach((t) => s.add(t))), O && setTimeout(() => {
        if (s.size === 0)
          O([]);
        else {
          const t = g.filter((a) => s.has(JSON.stringify(a)));
          O(t);
        }
      }, 0), s;
    });
  }, [L, J, g, O, ie]), wt = h((e) => Se.has(e), [Se]), xt = {
    table: J,
    expanded: E,
    isGroupable: l.length > 0,
    expanderColumn: Pe,
    processColumns: pe,
    groupByColumns: l,
    data: g,
    emptyStateComponent: We,
    isLoading: Qe,
    hiddenColumns: oe,
    footerLeftComponent: rt,
    // Pagination
    pageSize: z,
    setPageSize: ft,
    currentPage: ee,
    setCurrentPage: C,
    hideRowsPerPageSelector: ke,
    disablePagination: c?.disablePagination,
    rowsPerPageOptions: ke ? [] : c?.rowsPerPageOptions,
    // Manual pagination
    isManualPagination: c?.isManualPagination,
    onPaginationChange: c?.onPaginationChange,
    onRowsPerPageChange: c?.onRowsPerPageChange,
    totalPages: c?.totalPages,
    currentRowsPerPage: c?.currentRowsPerPage,
    // Filters
    columnFilters: G,
    setColumnFilter: vt,
    setColumnFilters: ge,
    getUniqueValuesForColumn: me,
    disableFilters: se,
    getColumnById: I,
    // Resize
    columnSizing: je,
    isResizing: lt,
    currentResizingColumn: ct,
    handleResize: dt,
    handleResizeStart: gt,
    handleResizeEnd: ht,
    // Dimensions
    height: Ze,
    minHeight: Be,
    maxHeight: et,
    enableVirtualization: N,
    // Selection
    enableSelection: L,
    onSelectionChange: O,
    selectedRows: Se,
    toggleRowSelection: Rt,
    toggleAllRowsSelection: yt,
    isRowSelected: wt,
    isRowSelectionDisabled: ie,
    selectedRowIndex: K,
    selectedRowId: H,
    preSelectedRows: y,
    // Drag
    isDraggable: Y?.isDraggable,
    onDragStart: Y?.onDragStart,
    onDragEnd: Y?.onDragEnd,
    dragLabelColumnId: Y?.dragLabelColumnId,
    dragCountSuffix: Y?.dragCountSuffix,
    // Search
    searchPlaceholder: q?.searchPlaceholder,
    onSearchChange: at,
    searchLeftComponent: q?.searchLeftComponent,
    disableTableSearch: q?.disableTableSearch,
    // Row interaction
    handleRowClick: St,
    handleRowRightClick: mt,
    handleRowEnter: Pt,
    handleRowLeave: pt,
    onRowClick: ae,
    onRowEnter: le,
    onRowLeave: ce,
    rowSx: tt,
    headerSx: nt,
    // Column visibility sidebar
    showColumnVisibilitySidebar: T
  };
  return /* @__PURE__ */ D(Ve.Provider, { value: xt, children: S });
}
export {
  x as F,
  Xt as T,
  ne as a,
  Ht as u
};
